// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// export const SendEmailAPI = createAsyncThunk(
//     "SendEmailAPI",
//     async (formData, { rejectWithValue }) => {
//         try {
//             const response = await fetch("https://solutions.bitsclan.us/api/send-service-email", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(formData),
//             });

//             if (!response.ok) {
//                 const errorData = await response.json();
//                 return rejectWithValue(errorData);
//             }

//             const result = await response.json();
//             return result;
//         } catch (error) {
//             if (error.response && error.response.data) {
//                 return rejectWithValue(error.response.data);
//             }
//             return rejectWithValue({ message: "Something went wrong" });
//         }
//     }
// );

// export const SendEmailContactUsAPI = createAsyncThunk(
//     "SendEmailContactUsAPI",
//     async (formData, { rejectWithValue }) => {
//         try {
//             const response = await fetch("https://solutions.bitsclan.us/api/contact-us-email", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(formData),
//             });

//             if (!response.ok) {
//                 const errorData = await response.json();
//                 return rejectWithValue(errorData);
//             }

//             const result = await response.json();
//             return result;
//         } catch (error) {
//             if (error.response && error.response.data) {
//                 return rejectWithValue(error.response.data);
//             }
//             return rejectWithValue({ message: "Something went wrong" });
//         }
//     }
// );

// export const GoHighLevelAPI = createAsyncThunk(
//     "GoHighLevelAPI",
//     async (formData, { rejectWithValue }) => {
//         try {
//             const response = await fetch("https://rest.gohighlevel.com/v1/contacts", {
//                 method: "POST",
//                 headers: {
//                     "Authorization": `Bearer ${process.env.REACT_APP_GHL_API_KEY}`, // store API key in .env
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(formData),
//             });

//             if (!response.ok) {
//                 const errorData = await response.json();
//                 return rejectWithValue(errorData);
//             }

//             const result = await response.json();
//             return result;
//         } catch (error) {
//             if (error.response && error.response.data) {
//                 return rejectWithValue(error.response.data);
//             }
//             return rejectWithValue({ message: "Something went wrong" });
//         }
//     }
// );

// const initialState = {
//     data: null,
//     loading: false,
//     error: null,
// };

// const SendEmailApiSlice = createSlice({
//     initialState,
//     name: "SendEmailApiSlice",
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             .addCase(SendEmailAPI.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(SendEmailAPI.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.data = action.payload;
//             })
//             .addCase(SendEmailAPI.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Something went wrong";
//             });
//     },

//     extraReducers: (builder) => {
//         builder
//             .addCase(SendEmailContactUsAPI.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(SendEmailContactUsAPI.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.data = action.payload;
//             })
//             .addCase(SendEmailContactUsAPI.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Something went wrong";
//             });
//     },

//     extraReducers: (builder) => {
//         builder
//             .addCase(GoHighLevelAPI.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(GoHighLevelAPI.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.data = action.payload;
//             })
//             .addCase(GoHighLevelAPI.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Something went wrong";
//             });
//     }
// })

// export const { } = SendEmailApiSlice.actions;
// export default SendEmailApiSlice.reducer;


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// ==================== Thunks ====================

export const SendEmailAPI = createAsyncThunk(
    "SendEmailAPI",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await fetch("https://solutions.bitsclan.us/api/send-service-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                return rejectWithValue(errorData || { message: "Failed to send email" });
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error("SendEmailAPI Error:", error);
            return rejectWithValue({ message: error.message || "Something went wrong" });
        }
    }
);

export const SendEmailContactUsAPI = createAsyncThunk(
    "SendEmailContactUsAPI",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await fetch("https://solutions.bitsclan.us/api/contact-us-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                return rejectWithValue(errorData || { message: "Failed to send contact email" });
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error("SendEmailContactUsAPI Error:", error);
            return rejectWithValue({ message: error.message || "Something went wrong" });
        }
    }
);

export const GoHighLevelAPI = createAsyncThunk(
    "GoHighLevelAPI",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await fetch("https://rest.gohighlevel.com/v1/contacts", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_GHL_API_KEY}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                return rejectWithValue(errorData || { message: "Failed to create contact" });
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error("GoHighLevelAPI Error:", error);
            return rejectWithValue({ message: error.message || "Something went wrong" });
        }
    }
);

// ==================== Slice ====================

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const SendEmailApiSlice = createSlice({
    name: "SendEmailApiSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Send Email
        builder
            .addCase(SendEmailAPI.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(SendEmailAPI.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(SendEmailAPI.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || { message: "Something went wrong" };
            });

        // Contact Us Email
        builder
            .addCase(SendEmailContactUsAPI.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(SendEmailContactUsAPI.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(SendEmailContactUsAPI.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || { message: "Something went wrong" };
            });

        // Go HighLevel
        builder
            .addCase(GoHighLevelAPI.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GoHighLevelAPI.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(GoHighLevelAPI.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || { message: "Something went wrong" };
            });
    },
});

export default SendEmailApiSlice.reducer;